import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, Inject } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sponsorship-comms-dialog',
  templateUrl: './sponsorship-comms-dialog.component.html',
  styleUrls: ['./sponsorship-comms-dialog.component.scss']
})
export class SponsorshipCommsDialogComponent {
  constructor(
    private http: HttpClient,
  ){
    let httpHeader = new HttpHeaders({ 'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
      'Pragma': 'no-cache',
    });

    this.http.get(environment.dbUrl + '/sponsorship.html',  {responseType: 'text', headers: httpHeader}).subscribe(
     data =>  { this.sponsorshipMessage = data; }
    )
  }

  sponsorshipMessage;

}